import Select from "react-select";
import useSelectSecondary from "../../shared/hooks/use-selectSecondary";

const SelectSecondaryComponent = ({ options, placeholder, name, components, menuIsOpen, onMenuOpen, onMenuClose, onInputChange, inputValue, onChange, value, onFocus, onBlur, isSearchable, arrow }: any) => {
    let styles = useSelectSecondary(arrow);

    return (
        <Select
            options={options}
            name={name}
            className="w-full select-input"
            placeholder={placeholder}
            styles={styles}
            components={components}
            isSearchable={isSearchable}
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            onInputChange={onInputChange}
            inputValue={inputValue}
            onChange={onChange}
            value={value}
            noOptionsMessage={() => null}
            onFocus={onFocus}
            onBlur={onBlur}
            closeMenuOnSelect={false}
            blurInputOnSelect={false}
        />
    );
};

export default SelectSecondaryComponent;
